<template>
    <div data-component="CategoryNavDropdown"
         class="category-nav-dropdown">
        <a class="btn btn-default category-nav-dropdown__toggle"
           :data-analytics-id="toggleAnalyticsId"
           @click.prevent="showDropdown = !showDropdown">
            <i v-if="isFavourite(modelValue)"
               class="fa-solid fa-star" />
            <span class="category-nav-dropdown__name">
                {{ modelValue ? modelValue.name : '' }}
            </span>
            <i class="fa-solid fa-caret-down"></i>
        </a>

        <div class="dropmenu"
             :class="{'dropmenu--show': showDropdown}"
             @click.prevent="showDropdown = false">
            <ul>
                <li v-for="(category, index) in categories"
                    :key="category.ID"
                    :class="{active: modelValue && category.ID === modelValue.ID}">
                    <a :data-analytics-id="itemAnalyticsId(index)"
                       @click.prevent="select(category)">
                        <i v-if="isFavourite(category)"
                           class="fa-solid fa-star" />
                        {{ category.name }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import CategoryNav from '@/epos/vue/components/Generic/CategoryNav';

export default {
    props: {
        /**
         * The currently selected category.
         *
         * @type {Category}
         */
        modelValue: {
            type: Object,
            required: true,
        },

        /**
         * The categories to list in the dropdown.
         *
         * @type {Category[]}
         */
        categories: {
            type: Array,
            required: true,
        },

        /**
         * @type {String}
         */
        analyticsIdPrefix: {
            type: String,
            required: true,
        },
    },

    emits: ['update:modelValue'],

    data() {
        return {
            /**
             * Is the dropdown menu open?
             *
             * @type {Boolean}
             */
            showDropdown: false,
        };
    },

    computed: {
        /**
         * @return {String|null}
         */
        toggleAnalyticsId() {
            return this.analyticsIdPrefix
                ? `${this.analyticsIdPrefix} / Category Dropdown Toggle`
                : null;
        },
    },

    methods: {
        /**
         * @param {Category|null} category
         *
         * @return {boolean}
         */
        isFavourite(category) {
            return !!category && category.ID === CategoryNav.FAVOURITE_CAT_ID;
        },

        /**
         * @param {number} index
         *
         * @return {String}
         */
        itemAnalyticsId(index) {
            return `${this.analyticsIdPrefix} / Category Select / Index: ${index}`;
        },

        /**
         * @param {Category} category
         */
        select(category) {
            this.$emit('update:modelValue', category);
            this.showDropdown = false;
        },
    },
};
</script>

<style lang="less">
.category-nav-dropdown {
    position: relative;
}

.category-nav-dropdown__toggle {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 0 8px;

    .category-nav-dropdown__name {
        flex-grow: 1;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .fa-caret-down {
        flex-grow: 0;
        flex-shrink: 0;
    }
}
</style>
